module.exports = __webpack_public_path__ + "img/shards01.b167b88e.png";